import { Dispatch } from "react";
import db from "../../../db";
import { BasketContextAction, BasketContextActionEnum } from "../../../hooks";

export const updateDraftOrderBuyerId = async ({
  supplierId,
  newBuyerId,
  dispatch,
}: {
  supplierId: number;
  newBuyerId: number;
  dispatch: Dispatch<BasketContextAction>;
}) => {
  const existingDraftOrder = await db.draftOrders.get({
    RetailerId: newBuyerId,
    SupplierId: supplierId,
    initiator: "retailer",
  });

  if (existingDraftOrder) {
    await db.draftOrders
      .where({
        RetailerId: newBuyerId,
        SupplierId: supplierId,
        initiator: "retailer",
      })
      .delete();
  }
  const draftOrder = await db.draftOrders.get({
    RetailerId: 0,
    SupplierId: supplierId,
    initiator: "retailer",
  });

  if (!draftOrder) return;

  await db.draftOrders.update(draftOrder, {
    RetailerId: newBuyerId,
  });

  return dispatch({
    type: BasketContextActionEnum.CHANGE_ORDER,
    order: {
      ...draftOrder,
      RetailerId: newBuyerId,
      PriceTierId: draftOrder.PriceTierId ?? undefined,
    },
  });
};
